// Model
import model from '../../database/model/model.database';

// Name
import NAME from './name.database.vehicle';

export default model(NAME);
